import * as React from "react";
import { map } from "lodash";
import { EventCard } from "./EventCard";
import { EventItem } from "src/common/event/event.types";
import { useNavigate } from "react-router";
import { buildUrlV2, ROUTES } from "src/v2/routes";

interface Props {
  events: EventItem[];
}

const EventsList: React.FC<Props> = ({ events }) => {
  const navigate = useNavigate();

  return (
    <>
      {map(events, (event) => (
        <div key={event.id} className="col-3">
          <EventCard
            key={event.id}
            startDate={event.startDate}
            endDate={event.endDate}
            category={event.type}
            title={event.name}
            location={event.address}
            onDetailsClick={(): void => {
              navigate(buildUrlV2(ROUTES.EVENT_DETAIL, { id: event.id }));
            }}
          />
        </div>
      ))}
    </>
  );
};

export default EventsList;
